import { ColorEnum } from '@/constants/color'
import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const ScooterIcon: FC<SvgProps> = (props) => {
    return (
        <Svg fill="none" viewBox="0 0 16 16" width="16" height="16" {...props}>
            <Path
                fill={ColorEnum.GRAY_900}
                d="M9.2 11.551c1.098 0 2.03-.385 2.8-1.156.768-.771 1.152-1.706 1.152-2.804 0-1.098-.385-2.03-1.155-2.795-.77-.766-1.702-1.149-2.797-1.149-.583 0-1.152.068-1.707.204a5.655 5.655 0 0 0-1.6.672l2.257.943A2.294 2.294 0 0 1 9.6 7.633a2.28 2.28 0 0 1-.692 1.675 2.281 2.281 0 0 1-1.675.691h-4.39c.006.256.008.512.007.768-.002.256-.002.518-.002.784H9.2ZM3.03 8.8h4.205c.32 0 .594-.111.822-.334.228-.223.342-.497.342-.822a1.134 1.134 0 0 0-.717-1.06L4.84 5.39c-.489.458-.87.984-1.142 1.58a12.097 12.097 0 0 0-.666 1.83ZM9.2 12.935H2.848c-.383 0-.71-.135-.98-.405a1.334 1.334 0 0 1-.404-.979v-1.2c0-1.169.191-2.25.573-3.245a7.582 7.582 0 0 1 1.602-2.565 7.292 7.292 0 0 1 2.452-1.676c.948-.4 1.984-.601 3.109-.601.74 0 1.433.14 2.078.418a5.4 5.4 0 0 1 1.691 1.143 5.416 5.416 0 0 1 1.146 1.695c.28.647.42 1.343.42 2.087a5.218 5.218 0 0 1-.423 2.071 5.376 5.376 0 0 1-2.837 2.838 5.153 5.153 0 0 1-2.075.419Z"
            />
        </Svg>
    )
}

export default ScooterIcon
